var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableau(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4996 86.1751H67.4996V67.075H85.1246V60.2751H67.4996V41.175H60.4996V60.2751H43.0996V67.075H60.4996V86.1751Z",
    fill: "#E8762D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0248 113.775H33.9748V96.8H49.6748V91.5H33.9748V74.3H28.0248V91.5H12.2998V96.8H27.9998L28.0248 113.775Z",
    fill: "#C72037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0252 52.425H99.9752V35.45H115.9V30.35H99.9752V13.15H94.0252V30.35H78.3252V35.45H94.0252V52.425Z",
    fill: "#5B879B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2248 52.425H33.7498V35.225H49.6748V30.35H33.7498V13.15H28.2248V30.35H12.2998V35.225H28.2248V52.425Z",
    fill: "#EB9129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5498 127.15H66.6498V115.05H77.4748V110.6H66.6498V98.5H61.5498V110.6H50.9248V115.05H61.5498V127.15ZM112.075 77.9H117.175V66.025H128V61.35H117.175V49.475H112.075V61.35H101.45V66.025H112.075V77.9Z",
    fill: "#5C6692"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.0252 113.775H99.9752V96.8H115.9V91.5H99.9752V74.3H94.0252V91.5H78.3252V96.8H94.0252V113.775Z",
    fill: "#1F457E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.625 16.125V12.525H66V0.849976H62.175V12.525H51.55V16.125H62.175V27.8H66V16.125H76.625ZM10.625 77.05H14.45V65.375H25.075V61.775H14.425V50.3H10.625V61.775H0V65.6L10.625 65.4V77.05Z",
    fill: "#7199A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableau);
export default __webpack_public_path__ + "static/media/tableau.0bc1ea3ada8df0c27841a95d882e2432.svg";
export { ForwardRef as ReactComponent };